import {
  TeacherAssignmentInsertDocument,
  TeacherAssignmentInsertMutation,
  TeacherAssignmentInsertMutationVariables,
  TeacherAssignmentStudentGradeFragment,
  TeacherAssignmentStudentGradesDocument,
  TeacherAssignmentStudentGradesQuery,
  TeacherAssignmentStudentGradesQueryVariables,
  TeacherDeleteAssignmentDocument,
  TeacherDeleteAssignmentMutation,
  TeacherDeleteAssignmentMutationVariables,
  TeacherdeleteAssignmentUserDocument,
  TeacherDeleteAssignmentUserMutation,
  TeacherDeleteAssignmentUserMutationVariables,
  TeacherinsertAssigmentMarkDocument,
  TeacherInsertAssigmentMarkMutation,
  TeacherInsertAssigmentMarkMutationVariables,
  TeacherinsertAssigmentWithTeachingStructureDocument,
  TeacherInsertAssigmentWithTeachingStructureMutation,
  TeacherInsertAssigmentWithTeachingStructureMutationVariables,
  TeacherStudentsToAssignmentDocument,
  TeacherStudentsToAssignmentMutation,
  TeacherStudentsToAssignmentMutationVariables,
  TeacherUpdateAssignmentDocument,
  TeacherUpdateAssignmentMutation,
  TeacherUpdateAssignmentMutationVariables,
} from "../types";
import { client } from "../../client";
import { AssignmentFragment } from "../../shared/types";

// [Teacher] Get all the assignment students
// Mainly used for grading
export async function teacherGetAssignmentStudents(
  variables: TeacherAssignmentStudentGradesQueryVariables
): Promise<TeacherAssignmentStudentGradesQuery> {
  try {
    const result = await client.query<
      TeacherAssignmentStudentGradesQuery,
      TeacherAssignmentStudentGradesQueryVariables
    >({
      query: TeacherAssignmentStudentGradesDocument,
      variables,
    });
    return result.data;
  } catch (error) {
    throw Error(error);
  }
}

// [Teacher] Get the grades and students for an assignment
export async function teacherGetAssignmentStudentsGrades(
  variables: TeacherAssignmentStudentGradesQueryVariables
): Promise<Array<TeacherAssignmentStudentGradeFragment>> {
  try {
    const result = await client.mutate<
      TeacherAssignmentStudentGradesQuery,
      TeacherAssignmentStudentGradesQueryVariables
    >({
      mutation: TeacherAssignmentStudentGradesDocument,
      variables,
      fetchPolicy: "network-only",
    });
    return result.data.assigment_student_grade;
  } catch (error) {
    throw Error(error);
  }
}

// [Teacher] Insert new assignment
export async function teacherCreateAssignment(
  variables: TeacherAssignmentInsertMutationVariables
): Promise<AssignmentFragment> {
  try {
    const result = await client.mutate<
      TeacherAssignmentInsertMutation,
      TeacherAssignmentInsertMutationVariables
    >({
      mutation: TeacherAssignmentInsertDocument,
      variables,
    });
    return result.data.insert_assignments_one;
  } catch (error) {
    throw Error(error);
  }
}

// [Teacher] Update an assignment
export async function teacherUpdateAssignment(
  variables: TeacherUpdateAssignmentMutationVariables
): Promise<string> {
  try {
    const result = await client.mutate<
      TeacherUpdateAssignmentMutation,
      TeacherUpdateAssignmentMutationVariables
    >({
      mutation: TeacherUpdateAssignmentDocument,
      variables,
    });
    return result.data.update_assignments_by_pk.id;
  } catch (error) {
    throw Error(error);
  }
}

// [Teacher] Delete an assignment
export async function teacherDeleteAssignment(
  variables: TeacherDeleteAssignmentMutationVariables
): Promise<string> {
  try {
    const result = await client.mutate<
      TeacherDeleteAssignmentMutation,
      TeacherDeleteAssignmentMutationVariables
    >({
      mutation: TeacherDeleteAssignmentDocument,
      variables,
    });
    return result.data.delete_assignments_by_pk.id;
  } catch (error) {
    throw Error(error);
  }
}

export async function teacherInsertAssigmentUsers(
  variables: TeacherStudentsToAssignmentMutationVariables
): Promise<number> {
  try {
    const result = await client.mutate<
      TeacherStudentsToAssignmentMutation,
      TeacherStudentsToAssignmentMutationVariables
    >({
      mutation: TeacherStudentsToAssignmentDocument,
      variables,
    });
    return result.data.insert_assignment_user.affected_rows;
  } catch (e) {
    throw e;
  }
}

export async function teacherDeleteAssigmentUsers(
  variables: TeacherDeleteAssignmentUserMutationVariables
): Promise<number> {
  try {
    const result = await client.mutate<
      TeacherDeleteAssignmentUserMutation,
      TeacherDeleteAssignmentUserMutationVariables
    >({
      mutation: TeacherdeleteAssignmentUserDocument,
      variables,
    });
    return result.data.delete_assignment_user.affected_rows;
  } catch (e) {
    throw e;
  }
}

export async function insertAssigmentTS(
  variables: TeacherInsertAssigmentWithTeachingStructureMutationVariables
): Promise<{ id: string }> {
  try {
    const response = await client.mutate<
      TeacherInsertAssigmentWithTeachingStructureMutation,
      TeacherInsertAssigmentWithTeachingStructureMutationVariables
    >({
      mutation: TeacherinsertAssigmentWithTeachingStructureDocument,
      variables,
    });
    return response.data.insert_assignments_one;
  } catch (e) {
    throw e;
  }
}

export async function setMarkForStudent(
  variables: TeacherInsertAssigmentMarkMutationVariables
): Promise<{ affected_rows: number }> {
  try {
    const response = await client.mutate<
      TeacherInsertAssigmentMarkMutation,
      TeacherInsertAssigmentMarkMutationVariables
    >({
      mutation: TeacherinsertAssigmentMarkDocument,
      variables,
    });

    return response.data.update_assignment_user;
  } catch (e) {
    throw e;
  }
}
